import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles } from '@material-ui/core';
import { Receipt as ReceiptModel } from '../../models/postcheckout/Receipt';
import CheckDetails from '../common/CheckDetails';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_Receipt_ReceiptTitle, String_Receipt_CheckLabel, String_Receipt_PaidDateTimeLabel,
     String_Receipt_AuthCodeLabel, String_Receipt_CardNumberLabel, String_Receipt_CardTypeLabel } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';

const useStyles = makeStyles({
    checkDetailsContainer: {
        backgroundColor: themePrimary.palette.grey[100],
        borderRadius: '6px',
        marginLeft:  ElementDimensions.margin10 + 'px',
        marginRight:  ElementDimensions.margin10 + 'px',
    },
    details: {
        width: '100%',
    },
    headerContainer: {
        paddingLeft: ElementDimensions.padding10 + 'px',
        paddingRight: ElementDimensions.padding10 + 'px',
        paddingTop: ElementDimensions.padding5 + 'px',
        paddingBottom: ElementDimensions.padding5 + 'px',
        width: '100%',
    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        width: '100%',
    },
    headerGridContainer: {
        display: 'flex',
    },
    headerTextLeft: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        color: themePrimary.palette.secondary.contrastText,
    },
    headerTextRight: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        textAlign: 'right',
        color: themePrimary.palette.secondary.contrastText,
    },
    logoContainer: {
        width: '100%',
        textAlign: 'center',
        backgroundColor: themePrimary.palette.grey[200],
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    logoContainerIsMobile: {
        width: '100%',
        textAlign: 'center',
        backgroundColor: themePrimary.palette.grey[200],
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
        position: 'absolute',
        bottom: '0',
    },
    titleContainer: {
        height: ElementDimensions.headerBarHeight + 'px',
        display: 'flex',
        textAlign: 'center',
        padding: ElementDimensions.padding5 + 'px',
    },
    titleInnerContainer: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

export interface EmailReceiptProps {
    receipt: ReceiptModel,
}

const EmailReceipt = (props: EmailReceiptProps) => {
    const { receipt } = props;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, 
        primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
        <div>
            <div className={classes.titleContainer}>
                <div className={classes.titleInnerContainer}>
                    <Typography variant="h6">
                        {String_Receipt_ReceiptTitle.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                </div>
            </div>
            <div className={classes.details}>
                <div className={classes.headerContainer}>
                    <div className={classes.headerGridContainer}>
                        <div className={classes.headerGrid}>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CheckLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.check_number}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_PaidDateTimeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.check_paid_date_time}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CardTypeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.payment_method}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CardNumberLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.card_number}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_AuthCodeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.auth_code}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.checkDetailsContainer}>
                    <CheckDetails details={receipt.check.details} isReceipt={true}/>
                </div>
            </div>
        </div>
    );
};

export default EmailReceipt;